import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
export const LayoutComponent = (props) => {
  const { t } = useTranslation(); // Access translations
  const [header, setHeader] = React.useState(null);
  const [footer, setFooter] = React.useState(null);
  React.useEffect(() => {
    setHeader(<Header  />);
    setFooter(<Footer footerBgClass='bg-white' trans={ t } />);
  }, [props.children]);
  return (
    <>
      {header}
      {props.children}
      {footer}
    </>
  );
};
LayoutComponent.propTypes = {
  children: PropTypes.node.isRequired,
};
export default LayoutComponent;
